import Vue from 'vue';


const app = {
	state: {
		lang: 'ZH_CN',
		btoken: '',
		ctoken: '',
		buserid: '',
		cuserid: '',
		username: '',
		temp: '',
		atval: '',
	},
	mutations: {
		setLang (state, val){
			state.lang = val
		},
		setToken (state, val){
			state.btoken = val
			localStorage.setItem("btoken",val);
		},
		setUserid (state, val){
			state.buserid = val
			localStorage.setItem("buserid",val);
		},
		setcToken (state, val){
			state.ctoken = val
			localStorage.setItem("ctoken",val);
		},
		setcUserid (state, val){
			state.cuserid = val
			localStorage.setItem("cuserid",val);
		},
		setUser (state, val){
			state.username = val
			localStorage.setItem("username",val);
		},
		setAtval (state, val){
			state.atval = val
			localStorage.setItem("useratval",val);
		},
		setTemp (state, val){
			state.temp = val
		}
	}
}

export default app;


// WEBPACK FOOTER //
// ./src/store/modules/app.js